/**
 * Wraps specified function with button keyboard logic
 * i.e. only "Space" or "Enter" keydowns will trigger
 * the function
 *
 * @param {object} e The keyboard event
 * @param {function} fn The function to be wrapped
 * @returns {object} The wrapped function
 */
export function keyDownButtonWrapper(e, fn) {
  if (e.key === "Enter" || e.key === " ") {
    fn();
  }
}
